export const HOVER_CLASS_EXTENSION = 'hover:font-bold';
